/* eslint-disable */
export default {
  order: 1,
  header: [
    {
      category: '概览',
      item: [
        {
          title: '',
          list: [
            {
              name: '什么是 EnOS',
              url: '/docs/enos/zh_CN/3.1.0/overview/enos_introduction.html'
            },
            {
              name: 'EnOS 优势',
              url: '/docs/enos/zh_CN/3.1.0/overview/advantage.html'
            },
            {
              name: '关键概念',
              url: '/docs/enos/zh_CN/3.1.0/overview/concepts.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    },
    {
      category: '产品文档',
      item: [
        {
          title: '应用构建',
          list: [
            {
              name: '数字孪生可视化',
              url: '/docs/dtv/zh_CN/3.1.0/overview.html'
            },
            {
              name: '统一监测',
              url: '/docs/monitor/zh_CN/3.1.0/overview/monitor_overview.html'
            },
            {
              name: '报表工具',
              url: '/docs/reporting/zh_CN/3.1.0/overview.html'
            },
            {
              name: '告警管理',
              url: '/docs/alarm-management/zh_CN/3.1.0/overview/about.html'
            },,
            {
              name: '告警引擎',
              url: '/docs/alert/zh_CN/3.1.0/learn/alert_overview.html'
            },
            {
              name: '工作管理',
              url: '/docs/wmt/zh_CN/3.1.0/about.html'
            },
            {
              name: '集群控制',
              url: '/docs/control/zh_CN/3.1.0/overview.html'
            },
            {
              name: '通知管理',
              url: '/docs/notification-mgmt/zh_CN/3.1.0/notification_center_overview.html'
            },
            {
              name: '应用门户',
              url: '/docs/app-portal/zh_CN/3.1.0/overview.html'
            },
            {
              name: '应用注册',
              url: '/docs/app-development/zh_CN/3.0.0/app_management/overview.html'
            },
            {
              name: 'API 管理',
              url: '/docs/apim/zh_CN/3.0.0/api_management_overview.html'
            }
          ]
        },
        {
          title: '数据管理与分析',
          list: [
            {
              name: '数据订阅',
              url: '/docs/data-subscription/zh_CN/3.1.0/data_subscription_overview.html'
            },
            {
              name: '数据归档',
              url: '/docs/data-archiving/zh_CN/3.1.0/archive_policy.html'
            },
            {
              name: '数据源注册',
              url: '/docs/data-source-reg-app/zh_CN/3.1.0/datasource_overview.html'
            },
            {
              name: '模型管理',
              url: '/docs/modelling-tool/zh_CN/3.1.0/overview/about.html'
            }
          ]
        },
        {
          title: '设备连接与管理',
          list: [
            {
              name: '设备连接',
              url: '/docs/device-connection/zh_CN/3.1.0/learn/message_flow.html'
            },
            {
              name: '设备管理',
              url: '/docs/device-connection/zh_CN/3.1.0/learn/device_lifecycle_management.html'
            },
            {
              name: '数据质量',
              url: '/docs/data-quality/zh_CN/3.1.0/overview/about.html'
            },
            {
              name: 'EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.4/edge_overview.html'
            }
          ]
        }
      ],
      layout: 'vertical',
      footer: {
        name: '查看所有产品',
        image: 'assets/images/header/document_center.svg',
        url: '/docs/zh_CN/3.1.0'
      },
      showListInMobile: false
    },
    {
      category: '教程',
      item: [
        {
          title: '数据集成',
          list: [
            {
              name: '将模拟设备连接到 EnOS Cloud',
              url: '/docs/device-connection/zh_CN/3.1.0/tutorial/connecting_device_simulated/index.html'
            },
            {
              name: '将模拟电表接入到 EnOS Edge',
              url: '/docs/enos-edge/zh_CN/2.4.4/tutorial/connecting_edge.html'
            }
          ]
        },
        {
          title: '数据开发',
          list: [
            {
              name: '评估风机设备的数据质量',
              url: '/docs/data-quality/zh_CN/3.1.0/tutorial.html'
            }
          ]
        },
        {
          title: '应用开发',
          list: [
            {
              name: '基于行业应用组件构建应用',
              url: '/docs/app-development/zh_CN/3.1.0/app_dev_workflow/index.html'
            },
            {
              name: '创建智能电池仪表盘',
              url: '/docs/dtv/zh_CN/3.1.0/tutorial/index.html'
            },
            {
              name: '创建可视化监测应用',
              url: '/docs/monitor/zh_CN/3.1.0/tutorial/overview.html'
            }
          ]
        }
      ],
      layout: 'horizontal',
      footer: {
        name: '查看所有教程',
        image: 'assets/images/header/tutorial_center.svg',
        url: '/docs/zh_CN/3.1.0/tutorial'
      },
      showListInMobile: false
    },
    {
      category: '开发资源',
      item: [
        {
          title: '',
          list: [
            {
              name: 'EnOS APIs',
              url: 'https://developer.enos-iot.com/zh_CN/enos-apis/'
            },
            {
              name: 'SDKs 和工具',
              url: 'https://developer.enos-iot.com/zh_CN/enos-sdks-tools/'
            }
          ]
        }
      ],
      layout: 'vertical',
      showListInMobile: true
    }
  ],
  content: [
    {
      category: '数据集成',
      item: [
        {
          name: '将模拟设备连接到 EnOS Cloud',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/zh_CN/3.1.0/tutorial/connecting_device_simulated/index.html'
        },
        {
          name: '将个人电脑连接到 EnOS Cloud',
          description: '预计用时: 110 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/device-connection/zh_CN/3.1.0/tutorial/connecting_pc/index.html'
        },
        {
          name: '将模拟电表通过 IEC104 规约接入到 EnOS Edge',
          description: '预计用时: 40 分钟',
          image: 'assets/images/tutorial/tutorial.png',
          url: '/docs/enos-edge/zh_CN/3.1.0/tutorial/connecting_edge.html'
        }
      ]
    },
    {
      category: '数据开发',
      item: [
        {
          name: '评估风机设备的数据质量',
          description: '预计用时: 30 分钟',
          image: 'assets/images/tutorial/quality_zh.png',
          url: '/docs/data-quality/zh_CN/3.1.0/tutorial.html'
        }
      ]
    },
    {
      category: '应用开发',
      item: [
        {
          name: '注册和管理应用',
          description: '预计用时: 40 分钟',
          image: 'assets/images/tutorial/app_zh.png',
          url: '/docs/app-development/zh_CN/3.1.0/app_management/managing_apps.html'
        },
        {
          name: '基于行业应用组件构建应用',
          description: '预计用时: 160 分钟',
          image: 'assets/images/tutorial/cbb_app_zh.png',
          url: '/docs/app-development/zh_CN/3.1.0/app_dev_workflow/index.html'
        },
        {
          name: '创建智能电池仪表盘',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/battery_dashboard_zh.png',
          url: '/docs/dtv/zh_CN/3.1.0/tutorial/index.html'
        },
        {
          name: '创建风电岗位工作台',
          description: '预计用时: 90 分钟',
          image: 'assets/images/tutorial/wind_dashboard_zh.png',
          url: '/docs/dtv/zh_CN/3.1.0/workbench/dtv.html'
        },
        {
          name: '创建纯水净化系统监控页面',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/water_monitoring_zh.png',
          url: '/docs/dtv/zh_CN/3.1.0/tutorial/monitor.html'
        },
        {
          name: '创建可视化监测应用',
          description: '预计用时: 80 分钟',
          image: 'assets/images/tutorial/monitor_app_zh.png',
          url: '/docs/monitor/zh_CN/3.1.0/tutorial/overview.html'
        }
      ]
    }
  ]
};
